const required = value => {
  if (value === 0) {
    return undefined
  }

  return value ? undefined : 'Required'
}

const exactLength = length => value =>
  value && value.length !== length ? `Must be ${length} characters` : undefined

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined

const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined

const match = firstValue => secondValue =>
  secondValue && secondValue !== firstValue
    ? `Password does not match`
    : undefined

const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

const isEmail = value =>
  value && !emailRegExp.test(value) ? 'Invalid email address' : undefined

const phoneNumberRegExp = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/

const isPhoneNumber = value =>
  value && !phoneNumberRegExp.test(value) ? 'Invalid phone number' : undefined

const isNumeric = value =>
  value && /[^\-0-9. ]/i.test(value) ? 'Only numbers allowed' : undefined

const isInteger = value =>
  value && /[^\-0-9]/i.test(value) ? 'Only whole numbers allowed' : undefined

const isAlphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only letters and numbers allowed'
    : undefined

const isBetween0and1 = value =>
  value && value > 0 && value < 1
    ? undefined
    : 'Value must be between 0 and 1 (exclusive)'

const isInRange = (min, max, label) => value =>
  value !== undefined &&
  value !== null &&
  value !== '' &&
  !(Number(value) >= min && Number(value) <= max)
    ? `${label} must be between ${min} and ${max} (United States)`
    : undefined

// bounding box around all 50 states (Hawaii to Alaska to eastern Maine);
// keep in sync with atlas_backend's latitude_parser/longitude_parser
const US_LATITUDE_MIN = 18.5
const US_LATITUDE_MAX = 72
const US_LONGITUDE_MIN = -180
const US_LONGITUDE_MAX = -66

const isLatitude = isInRange(US_LATITUDE_MIN, US_LATITUDE_MAX, 'Latitude')

const isLongitude = isInRange(US_LONGITUDE_MIN, US_LONGITUDE_MAX, 'Longitude')

const moduleIdRegExp = /^[0-9a-fA-F]{16}$/

const isModuleId = value =>
  value && !moduleIdRegExp.test(value)
    ? 'Must be 16 hexadecimal characters'
    : undefined

export {
  required,
  maxLength,
  minLength,
  match,
  exactLength,
  isEmail,
  isNumeric,
  isInteger,
  isAlphaNumeric,
  isBetween0and1,
  isPhoneNumber,
  isModuleId,
  isLatitude,
  isLongitude,
}
